import API_BASE_URL from './ApiConfig';

export const getDoctorNotes = async () => {

  try {
    const response = await fetch(`${API_BASE_URL}/api/doctor_notes`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch doctor notes');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
